var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsHorizontal = function SvgDotsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334M12.667 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334M3.333 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334"
  })));
};
export default SvgDotsHorizontal;